import { Address, BaseError, getChecksumAddressOrThrow } from "@silo/types";
import { Effect } from "effect";

export function toFormattedJson(value: unknown): string {
  return JSON.stringify(value, null, 2);
}

export class InteropError extends BaseError {
  public readonly _tag = "InteropError";
}

export function checksumAddressFromAddress(address: Address) {
  return Effect.gen(function* () {
    const checksumAddress = yield* Effect.try({
      try: () => getChecksumAddressOrThrow(address),
      catch: (cause) =>
        new InteropError({
          cause,
          message: `${address} is not a valid ChecksumAddress`,
        }),
    });

    return checksumAddress;
  });
}
